import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import React from 'react';

interface LomavisMoreInfoIconProps {
  /**
   * Text to display inside the tooltip when the info icon is hovered.
   */
  text: string;
  size?: number;
  show?: number;
  hide?: number;
}

/**
 * LomavisMoreInfoIcon
 *
 * A reusable info icon that shows a tooltip with explanatory text on hover.
 * Commonly used next to labels or metrics to give users more context.
 *
 * @param text - The tooltip content shown on hover
 */
const LomavisMoreInfoIcon: React.FC<LomavisMoreInfoIconProps> = ({
  text,
  size = 3,
  show = 0,
  hide = 100
}) => {
  return (
    <OverlayTrigger
      delay={{ show: show, hide: hide }}
      placement="auto"
      data-html2canvas-ignore="true"
      overlay={
        <Tooltip>
          <span
            className="text-gray-400 fw-bold d-block fs-7 text-start"
            title={text}
          >
            {text}
          </span>
        </Tooltip>
      }
    >
      <i
        className={`fa-regular fa-circle-info text-muted cursor-pointer fs-${size}`}
        data-html2canvas-ignore="true"
      ></i>
    </OverlayTrigger>
  );
};
export default LomavisMoreInfoIcon;
